import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";
import fotoMapa from "../../../../../img/fotoMapa.png";
import FooterAutorizacionVD from "../../../../../img/Footer_AutorizacionVD.png";

export const CartaConfidencialidadListaScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CARTA CONFIDENCIALIDAD";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_carta_conf: fechafg.fecha_carta_conf || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
        {/* Header */}
        <Header titulo={tituloFormulario} />
        {/* Contenido del formulario */}
        <div className="p-6">
          <div className="text-center mb-8">
            <h2 className={`text-xl font-bold mb-4 flex justify-center items-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              CARTA DE CONFIDENCIALIDAD PARA EVALUADORES DEL PROCEDIMIENTO DE
              EVALUACIONES DE PRUEBAS DE CONFIANZA Y DE PROTECCIÓN DE DATOS
              PERSONALES
            </h2>
          </div>

          <div className="space-y-6">
            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              <span className="mr-2">
                Yo{" "}
                {`${queryEvaluado.data?.nombre || ""} ${
                  queryEvaluado.data?.apellido_paterno || ""
                } ${queryEvaluado.data?.apellido_materno || ""}`}
              </span>
              Colaborador de SKA TRACKING AND SECURITY S.A. DE C.V. reconozco que
              podré tener acceso a datos personales, formularios, cuestionarios,
              procedimientos, estrategias, programas, productos, metodologías y
              otra información de carácter sensible y confidencial (en lo sucesivo
              “Información Confidencial”), de la cual pueden ser propietarios SKA
              TRACKING AND SECURITY S.A. DE C.V. y que la divulgación de dicha
              información puede causar daños o perjuicios a sus propietarios, por
              lo cual ME COMPROMETO:
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A mantener la información confidencial, sea que la haya adquirido
              en documentos, medios electromagnéticos o de forma verbal, reservada
              para el uso indispensable y necesario para cumplir con mis
              obligaciones y funciones.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A darle trato de la mayor confidencialidad, a no usarla para mi
              beneficio personal ni para el beneficio de mis superiores, socios,
              colaboradores, representantes o clientes.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A no divulgarla, comunicar, transmitir, duplicar, copiar o
              cualquier otra forma de reproducción por ningún medio sin la
              autorización expresa y por escrito de SKA TRACKING AND SECURITY S.A.
              DE C.V., ni a hacerla del conocimiento de personas ajenas a la
              empresa SKA TRACKING AND SECURITY S.A. DE C.V., ni a reproducirla o
              divulgarla por tercera persona, ni a permitir a terceros el manejo
              de documentación.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A devolver la información confidencial, en caso de terminación
              anticipada, de mi relación con SKA TRACKING AND SECURITY S.A. DE
              C.V., a la parte de la cual la hubiere obtenido o a su solicitud, a
              destruirla y a abstenerme de utilizarla o divulgarla en el futuro, y
              no permitir que se realicen copias no autorizadas de esta
              documentación.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A ser imparcial y objetivo, con las opiniones, resoluciones de
              cada uno de los asuntos tratados.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • Si tuviese que colaborar en otras áreas, no compartiré ningún tipo
              de información recibida por escrito u oralmente a persona no
              autorizada.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A no comentar con ninguna persona ajena al área de la Gerencia de
              Seguridad en el Transporte y Organizaciones, los procesos,
              metodologías, formularios, y cualquier información que derive de
              esta área.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              • A apegarme y cumplir con lo descrito en la presente carta de
              confidencialidad y de protección de datos personales, para lo cual
              declaro que comprendo los siguientes puntos:
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              1. “Información Confidencial” es cualquier información de naturaleza
              confidencial o propietaria que pudiera constituir un Secreto
              Industrial en términos de lo establecido en la Ley de la Propiedad
              Industrial y que sea revelada al Receptor por la Parte Reveladora,
              en cualquier forma y medio, incluyendo de manera enunciativa más no
              limitativa, de forma verbal, electrónica, visual, por escrito o en
              cualquier otra forma tangible, en el marco de las negociaciones que
              desarrollen o durante la prestación de los servicios del evaluador.
              La Información Confidencial incluirá, de manera enunciativa más no
              limitativa,  lo siguiente: las ideas, fórmulas, bases de datos,
              datos personales, normas, artículos, estudios, folletos,
              publicaciones, manuales, sistemas, procedimientos, informes,
              reportes técnicos, minutas, know how, secretos industriales,
              patentes, derechos de autor, software, licencias, datos,
              invenciones, algoritmos, técnicas, procesos, planes y proyectos de
              mercadotecnia, publicidad, estrategias, pronósticos, información
              confidencial de terceros, listas de clientes, de contactos, de
              proveedores, planes de negocios, análisis de mercado, conocimiento
              de mercado o cualquier otra información técnica, económica, de
              negocios o de cualquier otra índole que sea propiedad de la Parte
              Reveladora y/o clientes o potenciales clientes así como toda
              información relativa o relacionada con las operaciones, desarrollo
              de negocios, desarrollo de productos, desarrollo de sistemas,
              desarrollo de nuevos proyectos, finanzas o toda aquella información
              cuya divulgación y exposición, cualquiera que sea su forma,
              perjudique de forma alguna a la Parte Reveladora. Sin perjuicio de
              lo que a continuación se señala, el término “Información
              Confidencial” no significará ni incluirá, y en consecuencia las
              partes no tendrán obligación alguna al respecto, información que se
              demuestre de manera documental y fehacientemente que: (1) es
              conocida por el Receptor al tiempo de la revelación por la Parte
              Reveladora, (2) es o llega a ser públicamente conocida por medio de
              publicaciones, inspecciones a productos o de cualquier otra forma
              que no implique incumplimiento de este acuerdo, (3) es o ha sido
              desarrollada en forma independiente por el Receptor, sin la
              información confidencial de la Parte Reveladora, (4) es recibida por
              el Receptor de parte de un tercero sin restricciones similares ni
              quebrantamiento de este acuerdo o algún otro convenio de
              confidencialidad, debiendo informar a la Parte Reveladora que se
              encuentra en conocimiento de dicha información, (5) cuenta con
              autorización escrita de la Parte Reveladora para ser divulgada, o
              (6) es revelada por el Receptor para dar cumplimiento a exigencias
              legales, requerimientos gubernamentales, o si tal revelación es
              requerida por aplicación de la ley. En este último caso, si el
              Receptor es requerido por alguna autoridad judicial o administrativa
              para revelar la Información Confidencial o parte de la Información
              Confidencial, el Receptor deberá: (a) notificar de manera oportuna a
              la Parte Reveladora con anterioridad a la revelación, debiendo
              enviar una copia del requerimiento; (b) consultar con la Parte
              Reveladora la posibilidad de resistir tal requerimiento; (c) si es
              necesario cumplir con la revelación requerida, el Receptor deberá
              solicitar que se le dé tratamiento “Confidencial” a la información
              que se revele, de acuerdo con lo establecido en la legislación
              aplicable. La parte que revele la Información Confidencial será la
              “Parte Reveladora” y la parte que reciba la Información
              Confidencial será el “Receptor”
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              2. “Datos personales” es lo que define como tal la Ley Federal de
              Protección de Datos Personales en Posesión de Particulares y su
              Reglamento, e incluirá los “Datos Personales Sensibles” de acuerdo
              con la definición prevista en dichos ordenamientos.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              Si por alguna causa se me designara para participar en una
              evaluación en la que exista Conflicto de Interés con mi persona,
              notificaré de inmediato a mis superiores y me abstendré de
              participar.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              Si por algún motivo faltase a cualquiera de mis compromisos, acepto
              mi responsabilidad por cada uno de mis actos y sus posibles
              consecuencias.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              Convengo, desde ahora, que, en caso de faltar a mi convenio,
              indemnizaré a la empresa SKA TRACKING AND SECURITY S.A. DE C.V., por
              cualquier daño o perjuicio que le siga por motivo de, o en relación
              con mi falta al estricto cumplimiento o con uno o más de mis
              compromisos arriba descritos y a mantener a la empresa SKA TRACKING
              AND SECURITY S.A. DE C.V., en paz y a salvo por cualquier
              reclamación que pudiera surgir en su contra por motivo o en relación
              con cualquier violación a lo anterior.
            </p>

            <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
              Las obligaciones de confidencialidad bajo la presente Declaración
              seguirán teniendo vigencia aun después del vencimiento del contrato
              que realizo con esta empresa. Hasta por cinco años posteriores a la
              terminación de nuestra relación.
            </p>
          </div>
          <div className="flex justify-between items-center mt-4 w-full">
            <div className="flex items-center gap-2">
              <span className={`font-medium ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>FECHA:</span>
              <span className={`border-b w-64 text-center leading-none pb-1 ${isDarkMode ? "border-gray-500 text-gray-300" : "border-black"}`}>
                {queryFechaFG.data?.fecha_carta_conf
                  ? new Date(
                      new Date(queryFechaFG.data.fecha_carta_conf).getTime() +
                        24 * 60 * 60 * 1000
                    )
                      .toLocaleDateString("es-MX", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                      .replace(/\//g, "/")
                  : ""}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <span className={`font-medium ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>FIRMA:</span>
              <span className={`border-b w-64 ${isDarkMode ? "border-gray-500" : "border-black"}`}></span>
            </div>
          </div>
        </div>

        {/* Botones */}
        <div className="mt-4 mb-4 px-4">
          <div className="flex justify-between">
            <Button
              color="red"
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(-1);
              }}
              className={`bg-red-500 hover:bg-red-600 text-white ${isDarkMode ? "bg-red-600 hover:bg-red-700" : ""}`}
            >
              Regresar
            </Button>
            <Button color="blue" className={`z-10 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700" : ""}`} onClick={handlePrint}>
              Imprimir
            </Button>
          </div>
        </div>

        {/* Footer */}
        <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
          <p className="text-sm text-white px-4">
            <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
            su reproducción, copia o sacar este documento de las Instalaciones de
            Skyangel
          </p>
        </div>

        {/* Imprimir */}
        <div id="printableContent" style={{ display: "none" }}>
          <div className={`max-w-4xl mx-auto rounded-lg overflow-hidden mt-4 relative ${isDarkMode ? "bg-gray-800 text-white" : "bg-white text-gray-800"}`}>
            {/* Header */}
            <HeaderPrint titulo={tituloFormulario} />
            {/* Título del formulario */}
            <div id="headerContent" className="text-center">
              <h1
                className={`text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer ${isDarkMode ? "text-gray-200" : "text-black"}`}
                style={{
                  backgroundImage: `url(${fotoMapa})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {tituloFormulario}
              </h1>
            </div>

            {/* Contenido del formulario */}
            <div className="p-6">
              <div className="text-center mb-8">
                <h2 className={`text-xl font-bold mb-4 flex justify-center items-center ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
                  CARTA DE CONFIDENCIALIDAD PARA EVALUADORES DEL PROCEDIMIENTO DE
                  EVALUACIONES DE PRUEBAS DE CONFIANZA Y DE PROTECCIÓN DE DATOS
                  PERSONALES
                </h2>
              </div>

              <div className="space-y-6">
                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  <span className="mr-2">
                    Yo{" "}
                    {`${queryEvaluado.data?.nombre || ""} ${
                      queryEvaluado.data?.apellido_paterno || ""
                    } ${queryEvaluado.data?.apellido_materno || ""}`}
                  </span>
                  Colaborador de SKA TRACKING AND SECURITY S.A. DE C.V. reconozco que
                  podré tener acceso a datos personales, formularios,
                  cuestionarios, procedimientos, estrategias, programas,
                  productos, metodologías y otra información de carácter sensible
                  y confidencial (en lo sucesivo “Información Confidencial”), de
                  la cual pueden ser propietarios SKA TRACKING AND SECURITY S.A.
                  DE C.V. y que la divulgación de dicha información puede causar
                  daños o perjuicios a sus propietarios, por lo cual ME
                  COMPROMETO:
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A mantener la información confidencial, sea que la haya
                  adquirido en documentos, medios electromagnéticos o de forma
                  verbal, reservada para el uso indispensable y necesario para
                  cumplir con mis obligaciones y funciones.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A darle trato de la mayor confidencialidad, a no usarla para
                  mi beneficio personal ni para el beneficio de mis superiores,
                  socios, colaboradores, representantes o clientes.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A no divulgarla, comunicar, transmitir, duplicar, copiar o
                  cualquier otra forma de reproducción por ningún medio sin la
                  autorización expresa y por escrito de SKA TRACKING AND SECURITY
                  S.A. DE C.V., ni a hacerla del conocimiento de personas ajenas a
                  la empresa SKA TRACKING AND SECURITY S.A. DE C.V., ni a
                  reproducirla o divulgarla por tercera persona, ni a permitir a
                  terceros el manejo de documentación.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A devolver la información confidencial, en caso de terminación
                  anticipada, de mi relación con SKA TRACKING AND SECURITY S.A. DE
                  C.V., a la parte de la cual la hubiere obtenido o a su
                  solicitud, a destruirla y a abstenerme de utilizarla o
                  divulgarla en el futuro, y no permitir que se realicen copias no
                  autorizadas de esta documentación.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A ser imparcial y objetivo, con las opiniones, resoluciones de
                  cada uno de los asuntos tratados.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • Si tuviese que colaborar en otras áreas, no compartiré ningún
                  tipo de información recibida por escrito u oralmente a persona
                  no autorizada.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A no comentar con ninguna persona ajena al área de la Gerencia
                  de Seguridad en el Transporte y Organizaciones, los procesos,
                  metodologías, formularios, y cualquier información que derive de
                  esta área.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  • A apegarme y cumplir con lo descrito en la presente carta de
                  confidencialidad y de protección de datos personales, para lo
                  cual declaro que comprendo los siguientes puntos:
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  1. “Información Confidencial” es cualquier información de naturaleza
                  confidencial o propietaria que pudiera constituir un Secreto
                  Industrial en términos de lo establecido en la Ley de la
                  Propiedad Industrial y que sea revelada al Receptor por la Parte
                  Reveladora, en cualquier forma y medio, incluyendo de manera
                  enunciativa más no limitativa, de forma verbal, electrónica,
                  visual, por escrito o en cualquier otra forma tangible, en el
                  marco de las negociaciones que desarrollen o durante la
                  prestación de los servicios del evaluador. La Información
                  Confidencial incluirá, de manera enunciativa más no limitativa,
                   lo siguiente: las ideas, fórmulas, bases de datos, datos
                  personales, normas, artículos, estudios, folletos,
                  publicaciones, manuales, sistemas, procedimientos, informes,
                  reportes técnicos, minutas, know how, secretos industriales,
                  patentes, derechos de autor, software, licencias, datos,
                  invenciones, algoritmos, técnicas, procesos, planes y proyectos
                  de mercadotecnia, publicidad, estrategias, pronósticos,
                  información confidencial de terceros, listas de clientes, de
                  contactos, de proveedores, planes de negocios, análisis de
                  mercado, conocimiento de mercado o cualquier otra información
                  técnica, económica, de negocios o de cualquier otra índole que
                  sea propiedad de la Parte Reveladora y/o clientes o potenciales
                  clientes así como toda información relativa o relacionada con
                  las operaciones, desarrollo de negocios, desarrollo de productos,
                  desarrollo de sistemas, desarrollo de nuevos proyectos, finanzas
                  o toda aquella información cuya divulgación y exposición,
                  cualquiera que sea su forma, perjudique de forma alguna a la
                  Parte Reveladora. Sin perjuicio de lo que a continuación se
                  señala, el término “Información Confidencial” no significará ni
                  incluirá, y en consecuencia las partes no tendrán obligación
                  alguna al respecto, información que se demuestre de manera
                  documental y fehacientemente que: (1) es conocida por el Receptor
                  al tiempo de la revelación por la Parte Reveladora, (2) es o
                  llega a ser públicamente conocida por medio de publicaciones,
                  inspecciones a productos o de cualquier otra forma que no
                  implique incumplimiento de este acuerdo, (3) es o ha sido
                  desarrollada en forma independiente por el Receptor, sin la
                  información confidencial de la Parte Reveladora, (4) es recibida
                  por el Receptor de parte de un tercero sin restricciones
                  similares ni quebrantamiento de este acuerdo o algún otro
                  convenio de confidencialidad, debiendo informar a la Parte
                  Reveladora que se encuentra en conocimiento de dicha
                  información, (5) cuenta con autorización escrita de la Parte
                  Reveladora para ser divulgada, o (6) es revelada por el Receptor
                  para dar cumplimiento a exigencias legales, requerimientos
                  gubernamentales, o si tal revelación es requerida por aplicación
                  de la ley. En este último caso, si el Receptor es requerido por
                  alguna autoridad judicial o administrativa para revelar la
                  Información Confidencial o parte de la Información
                  Confidencial, el Receptor deberá: (a) notificar de manera
                  oportuna a la Parte Reveladora con anterioridad a la
                  revelación, debiendo enviar una copia del requerimiento; (b)
                  consultar con la Parte Reveladora la posibilidad de resistir tal
                  requerimiento; (c) si es necesario cumplir con la revelación
                  requerida, el Receptor deberá solicitar que se le dé
                  tratamiento “Confidencial” a la información que se revele, de
                  acuerdo con lo establecido en la legislación aplicable. La parte
                  que revele la Información Confidencial será la “Parte
                  Reveladora” y la parte que reciba la Información Confidencial
                  será el “Receptor”
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  2. “Datos personales” es lo que define como tal la Ley Federal
                  de Protección de Datos Personales en Posesión de Particulares y
                  su Reglamento, e incluirá los “Datos Personales Sensibles” de
                  acuerdo con la definición prevista en dichos ordenamientos.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  Si por alguna causa se me designara para participar en una
                  evaluación en la que exista Conflicto de Interés con mi persona,
                  notificaré de inmediato a mis superiores y me abstendré de
                  participar.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  Si por algún motivo faltase a cualquiera de mis compromisos,
                  acepto mi responsabilidad por cada uno de mis actos y sus
                  posibles consecuencias.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  Convengo, desde ahora, que, en caso de faltar a mi convenio,
                  indemnizaré a la empresa SKA TRACKING AND SECURITY S.A. DE C.V.,
                  por cualquier daño o perjuicio que le siga por motivo de, o en
                  relación con mi falta al estricto cumplimiento o con uno o más
                  de mis compromisos arriba descritos y a mantener a la empresa
                  SKA TRACKING AND SECURITY S.A. DE C.V., en paz y a salvo por
                  cualquier reclamación que pudiera surgir en su contra por motivo
                  o en relación con cualquier violación a lo anterior.
                </p>

                <p className={`text-justify ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                  Las obligaciones de confidencialidad bajo la presente
                  Declaración seguirán teniendo vigencia aun después del
                  vencimiento del contrato que realizo con esta empresa. Hasta por
                  cinco años posteriores a la terminación de nuestra relación.
                </p>
              </div>
              <div className="flex justify-between items-center mt-[68px] w-full">
                {/* Sección de la fecha */}
                <div className="flex items-center gap-2 flex-1">
                  <span className={`font-medium ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>FECHA:</span>
                  <div className={`border-b w-64 text-center leading-none pb-1 ${isDarkMode ? "border-gray-500" : "border-black"}`}>
                    <span className={`${isDarkMode ? "text-gray-300" : "text-gray-700"}`}>
                      {queryFechaFG.data?.fecha_carta_conf
                        ? new Date(
                            new Date(
                              queryFechaFG.data.fecha_carta_conf
                            ).getTime() +
                              24 * 60 * 60 * 1000
                          )
                            .toLocaleDateString("es-MX", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })
                            .replace(/\//g, "/")
                        : ""}
                    </span>
                  </div>
                </div>

                {/* Sección de la firma */}
                <div className="flex items-center gap-2 flex-1">
                  <span className={`font-medium ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>FIRMA:</span>
                  <span className={`border-b w-64 leading-none pb-3 ${isDarkMode ? "border-gray-500" : "border-black"}`}></span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-[200px]"></div>
          {/* Footer */}
          <div className={`bg-customBlue/90 py-2 rounded-b-lg w-full ${isDarkMode ? "bg-blue-800/90" : ""}`}>
            <p className="text-white text-xs text-center font-light px-4">
              <span className="font-medium">DOCUMENTO CONFIDENCIAL</span> •
              Prohibida su reproducción o copia fuera de las instalaciones de
              Skyangel.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};